import {
  FEATURED_IMAGE_SOUTH_FLORIDA_GUIDE,
  FEATURED_IMAGE_SOUTH_FLORIDA_GUIDE_ALT,
  FEATURED_IMAGE_SOUTH_FLORIDA_GUIDE_CAPTION,
} from "@/data/blogData";

/**
 * Conditionally rendered supporting visual (lazy-loaded). Renders nothing
 * until a verified image URL is supplied to its constant, so no broken image
 * or empty placeholder graphic is ever shown. Filling in the URL later needs
 * no code change here.
 */
export function SupportingVisual({
  src,
  alt,
  caption,
  width,
  height,
}: {
  src: string;
  alt: string;
  caption: string;
  width: number;
  height: number;
}) {
  if (!src) return null;
  return (
    <figure className="my-8 group">
      <div className="overflow-hidden rounded-2xl shadow-lg border border-border bg-[#0B1F3D]">
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          loading="lazy"
          decoding="async"
          className="w-full h-auto object-cover block"
        />
      </div>
      <figcaption className="mt-3 text-xs sm:text-sm text-muted-foreground text-center italic leading-relaxed px-2">
        {caption}
      </figcaption>
    </figure>
  );
}

/**
 * Featured image — rendered with authentic Before & After project photograph,
 * responsive editorial title overlay matching the Precision brand, and
 * the required caption.
 */
export function FeaturedImage() {
  if (!FEATURED_IMAGE_SOUTH_FLORIDA_GUIDE) return null;
  return (
    <figure className="mb-10 group" id="featured-image">
      <div className="relative overflow-hidden rounded-2xl shadow-xl border border-border bg-[#0B1F3D]">
        <img
          src={FEATURED_IMAGE_SOUTH_FLORIDA_GUIDE}
          alt={FEATURED_IMAGE_SOUTH_FLORIDA_GUIDE_ALT}
          width={875}
          height={375}
          loading="eager"
          fetchPriority="high"
          className="w-full h-auto object-cover block"
        />

        {/* Title Treatment: SOUTH FLORIDA POOL REMODELING GUIDE */}
        <div className="absolute top-3 left-3 sm:top-5 sm:left-5 z-10 pointer-events-none">
          <div className="bg-[#0B1F3D]/85 backdrop-blur-md px-3.5 py-2 sm:px-4 sm:py-2.5 rounded-lg border border-white/15 shadow-lg max-w-[240px] sm:max-w-[280px]">
            <span className="block text-[10px] sm:text-xs font-semibold tracking-wider text-[#00A3D9] uppercase mb-0.5">
              Planning Guide
            </span>
            <p className="text-white font-extrabold text-xs sm:text-sm tracking-wide leading-tight uppercase font-sans">
              SOUTH FLORIDA
              <br />
              <span className="text-white/95">POOL REMODELING GUIDE</span>
            </p>
          </div>
        </div>
      </div>
      <figcaption className="mt-3 text-xs sm:text-sm text-muted-foreground text-center italic leading-relaxed px-2">
        {FEATURED_IMAGE_SOUTH_FLORIDA_GUIDE_CAPTION}
      </figcaption>
    </figure>
  );
}
